export default __webpack_public_path__ + "static/media/editPencil.ed0783e9.svg";